import { AxiosInstancePlus } from '@tencent/oneid-request';
import { IResponseType } from 'common/constants/Types';
import { httpOauth2 } from 'common/http';
import type { ICaptchaReportParams } from 'common/utils/captchaRequest';
import { newCaptchaRequest } from 'common/utils/captchaRequest';

class Oauth2Api {
  public axiosInstance: AxiosInstancePlus = httpOauth2;

  public prefixURL = '/v1';

  // 获取已认证用户可切换的企业列表
  getAuthenticatedAccounts(params: { app?: string }): Promise<IResponseType> {
    return this.axiosInstance.get(`${this.prefixURL}/authenticated/accounts`, { params });
  }
  /** 绑定手机号发送短信 */
  sendVerificationCode(
    params: { mobile: string; state_token: string },
    configs?: Record<string, any>,
    reportParams?: ICaptchaReportParams,
  ): Promise<
    IResponseType<{ state_token?: string; expires_in?: number; captcha?: any; status?: string }>
  > {
    return newCaptchaRequest((captchaVerification) => {
      return this.axiosInstance.post(
        `${this.prefixURL}/auth/sms/code/send`,
        {
          ...params,
          captchaVerification,
        },
        configs,
      );
    }, reportParams);
  }

  /** 绑定手机号短信验证码验证 */
  bindMobileSMSVerify(
    params: {
      code: string;
      state_token: string;
    },
    configs?: Record<string, any>,
  ): Promise<IResponseType<{ redirect_uri?: string }>> {
    return this.axiosInstance.post(`${this.prefixURL}/auth/sms/code/verify`, params, configs);
  }
  /** 检查链接状态 */
  SMSPageInit(
    params: {
      state_token: string;
    },
    configs?: Record<string, any>,
  ): Promise<IResponseType> {
    return this.axiosInstance.post(`${this.prefixURL}/auth/sms/code/init`, params, configs);
  }
}

export default new Oauth2Api();
